export enum PartialDatePrecision {
  DAY = 'day',
  MONTH = 'month',
  YEAR = 'year'
}

export type PartialDateType = {
  date?: string | null;
  precision?: PartialDatePrecision | string | null;
};
